import $ from 'jquery'
import 'jquery-match-height'
import Screen from './screen'

const screen = new Screen()

export default class Listing {
  constructor() {
    this.elm = document.querySelector('html')
  }

  init() {
    this.packageMatchHeight()
  }

  packageMatchHeight() {
    if (screen.isPC) {
      $('.p-packageDetail__item:nth-child(1) .p-packageDetail__box, .p-packageDetail__item:nth-child(3) .p-packageDetail__box').matchHeight()
    }

    // resize
    $(window).on('breakpointChange', () => {
      $('.p-packageDetail__box').removeAttr('style')
    })
  }

}
